    $(document).ready(function () {
        $(".tpl__js-anchor-link").on("click", function (e) {
            e.preventDefault();
            var t = $(this).attr("href"),
                l = $(t).offset().top - 30;
            $(".tpl__js-open-menu-btn").hasClass("tpl__is-active") &&
            ($(".tpl__js-open-menu-btn").removeClass("tpl__is-active"),
                $("html").removeClass("tpl__is-fixed"),
                $(".tpl-menu").removeClass("tpl__is-opened")),
                $("html, body").animate({scrollTop: l}, 400);
        }),
        $(".tpl__js-open-menu-btn").on("click", function (e) {
            e.preventDefault(),
                $(this).toggleClass("tpl__is-active"),
                $("html").toggleClass("tpl__is-fixed"),
                $(".tpl-menu").toggleClass("tpl__is-opened");
        }),
        $(".tpl__js-required-input").on("focus", function () {
            $(this).hasClass("tpl__is-error") && $(this).removeClass("tpl__is-error");
        }),
        $(".tpl-form [type=checkbox]").each(function () {
            $(this).on("change", function (e) {
                $(this).prop("checked")
                    ? $(this)
                        .parents(".tpl-form-checkbox__label")
                        .find(".tpl-form-input__error")
                        .css("display", "none")
                    : $(this)
                        .parents(".tpl-form-checkbox__label")
                        .find(".tpl-form-input__error")
                        .css("display", "block");
            });
        }),
        $(".tpl-marquee__init").marquee({
            delayBeforeStart: 0,
            duplicated: !0,
            startVisible: !0,
        });
    }),
    document.addEventListener("DOMContentLoaded", function () {
        let e = 0,
            t = document.querySelectorAll(".tpl-offer__license");
        t.length > 0 &&
        (t.forEach(function (t) {
            e = Math.max(e, t.offsetHeight);
        }),
            t.forEach(function (t) {
                t.style.minHeight = e + "px";
            }));
    });
    document.addEventListener('DOMContentLoaded', function () {
        const e = $('.tpl-scoremeter');

        if (e.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);

            let scoreDisplay = $('.tpl-scoremeter__rating-value_display'),
                arrow = $('.tpl-scoremeter__arrow'),
                maxScore = parseInt(e.attr('data-max-score')),
                score = parseInt($('.tpl-scoremeter__rating-value_display').text()),
                rawScore = queryParams.get('mfoscore:z5g');

            const scoreDescriptions = {
                low: 'У вас низкий кредитный рейтинг, из‑за этого некоторые компании могут ограничивать максимальную сумму выдачи',
                medium: 'У вас средний кредитный рейтинг, из‑за этого некоторые компании могут ограничивать максимальную сумму выдачи',
                high: 'У вас хороший кредитный рейтинг, но некоторые компании всё равно могут ограничить максимальную сумму выдачи',
            };

            if (Number.isNaN(score)) {
                const scoreFromQuery = rawScore ? parseInt(rawScore, 10) : NaN;

                if (!Number.isNaN(scoreFromQuery)) {
                    score = scoreFromQuery;
                } else {
                    const storageKey = 'score_meter_fallback';
                    const stored = sessionStorage.getItem(storageKey);
                    const storedScore = stored ? parseInt(stored, 10) : NaN;

                    if (!Number.isNaN(storedScore)) {
                        score = storedScore;
                    } else {
                        const fallbackScores = [316, 373, 420, 446, 511, 570, 610];
                        score = fallbackScores[Math.floor(Math.random() * fallbackScores.length)];
                        sessionStorage.setItem(storageKey, String(score));
                    }
                }
            }

            scoreDisplay.prop('Counter', 0).animate(
                {Counter: score},
                {
                    duration: 1000,
                    easing: 'swing',
                    step: function (t) {
                        $(this).text(Math.ceil(t));
                    }
                }
            );

            function updateTooltip(score) {
                const percentage = Math.floor((100 * score) / maxScore);
                const tooltipElement = $('.tpl-scoremeter__rating-value');

                if (percentage <= 33) {
                    tooltipElement.attr('data-tooltip', scoreDescriptions.low);
                } else if (percentage <= 66) {
                    tooltipElement.attr('data-tooltip', scoreDescriptions.medium);
                } else {
                    tooltipElement.attr('data-tooltip', scoreDescriptions.high);
                }
            }

            updateTooltip(score);

            function updateArrowPosition(score) {
                const rotationAngle = (180 * score) / maxScore - 90;
                arrow.css({
                    transform: `rotate(${rotationAngle}deg)`
                });
            }

            updateArrowPosition(score);
        }
    })